import { useEffect, useState } from 'react';
import { LATAM_BASES, normalizeLatamBase } from '../../utils/market';

const fmt = (code) => `${LATAM_BASES[code].symbol} 100${LATAM_BASES[code].decimals ? ',00' : ''}`;

/**
 * "Valores em": moeda em que os valores do bot LATAM são escritos (planos,
 * ofertas, disparo...). O comprador paga sempre convertido na moeda dele.
 * Trocar pede confirmação logo abaixo (os números não são convertidos).
 * Só visual, sem API.
 */
export default function LatamBasePicker({ value, onChange, saving = false }) {
    const current = normalizeLatamBase(value);
    const [pending, setPending] = useState(null);

    useEffect(() => {
        if (!pending) return;
        const onKey = (e) => { if (e.key === 'Escape') setPending(null); };
        document.addEventListener('keydown', onKey);
        return () => document.removeEventListener('keydown', onKey);
    }, [pending]);

    const pick = (code) => {
        if (saving || code === current) return;
        setPending(code);
    };

    const confirm = () => {
        const code = pending;
        setPending(null);
        onChange?.(code);
    };

    return (
        <div>
            <div role="radiogroup" aria-label="Valores em" aria-busy={saving}
                className="grid grid-cols-4 gap-1">
                {Object.keys(LATAM_BASES).map((code) => {
                    const active = code === current;
                    return (
                        <button key={code} type="button" role="radio" aria-checked={active}
                            title={`Escrever os valores do bot em ${code}`}
                            onClick={() => pick(code)}
                            className={`inline-flex items-center justify-center gap-1 h-7 rounded-md border text-[11px] font-medium transition-colors ${
                                active ? 'border-teal-500/60 bg-teal-500/15 text-white' : 'border-white/10 text-white/55 hover:text-white hover:bg-white/[0.05]'
                            }`}>
                            <img alt="" className="w-4 h-3 object-cover rounded-[2px]"
                                src={`https://flagcdn.com/w20/${LATAM_BASES[code].flag}.png`} />
                            {code}
                        </button>
                    );
                })}
            </div>

            {pending && (
                <div role="alertdialog" aria-label={`Valores em ${pending}`}
                    className="mt-3 rounded-lg border border-amber-400/20 bg-amber-400/[0.06] p-2.5">
                    <p className="text-xs font-semibold mb-1">Escrever os valores em {pending}?</p>
                    <p className="text-[11px] text-white/60 leading-relaxed mb-2.5">
                        Os números não serão convertidos: um valor que hoje é {fmt(current)} passa a ser {fmt(pending)}.
                        Revise planos, ofertas e disparos.
                    </p>
                    <div className="flex justify-end gap-2">
                        <button type="button" onClick={() => setPending(null)}
                            className="h-7 px-2.5 rounded-md border border-white/10 text-white/60 hover:text-white hover:bg-white/[0.04] text-[11px]">
                            Cancelar
                        </button>
                        <button type="button" onClick={confirm}
                            className="h-7 px-2.5 rounded-md text-[11px] font-medium text-white"
                            style={{ background: 'linear-gradient(135deg, var(--purple), #7c3aed)' }}>
                            Usar {pending}
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
}
